define(
    'viewmodels/secured/subscription/plan',[
        "providers/dataprovider",
        "viewmodels/ViewModel",
        "i19n!i19n/strings",
        "plugins/router",
        "plugins/dialog"
    ],
    function (dataProvider, ViewModel, i19n, router, dialog) {
        var vm = new ViewModel({
            i19n: i19n,
            plan: {
                _modal: 'trial',
                plan: '',
                planPrice: 0,
                additionalUserPrice: 0,
                includedUsers: 0,
                activeUsers: 0,
                activeGuest: 0,
                subsUsers: 0,
                subsGuest: 0,
                code: 0,
                title: '',
                price: 0,
                pricePerUser: 0,
                includedUsers: 0,
                isCurrent: false
            },
            currentPlan: 0,
            isManageSubscription: ko.observable(false),
            du_starterText: ko.observable('Current Plan'),
            du_standardText: ko.observable('Upgrade to Standard'),
            du_plusText: ko.observable('Upgrade to Plus'),

            du_isOverPlan1: ko.observable(false),
            du_isOverPlan2: ko.observable(false),
            du_isOverPlan3: ko.observable(false),
        });

        vm.activate = function (p) {
            vm.du_isSelectedPlan1(false);
            vm.du_isSelectedPlan2(false);
            vm.du_isSelectedPlan3(false);
            vm.du_isSelectUserQuantityEnabled(false);
            vm.isManageSubscription(!(!p || p == false));
            
            if (!vm.isManageSubscription()) {
                window.location.replace(window.location.origin + window.location.pathname + "#pricing/0");
                
                return false;
            }
            vm.plan._modal = vm.isManageSubscription() ? 'adduser' : 'trial';

            return dataProvider
            .persons
            .getPersons()
            .done(function (data) {

                var psum = { activeGuest: 0, activeUsers: 0 };
                _.map(data, function (itm) {
                    if (itm.personType == 1) {
                        psum.activeGuest++;
                    }
                    if (itm.personType != 1 && itm.personType != 0) {
                        psum.activeUsers++;
                    }                    
                });

                vm.plan.activeGuest = psum.activeGuest;
                vm.plan.activeUsers = psum.activeUsers;
                
                dataProvider.settings
                .getUsageSetting()
                .done(function (storage) {
                    vm.totalSpaceUsedMB = storage.totalSpaceUsedMB;
                    
                    //if (window.fileplan && window.fileplan.instanceCode && window.fileplan.instanceCode == "radfp01") {
                    //    _test();
                    //}

                    setSubscriptionCustomerSubs();                    
                });

                function setSubscriptionCustomerSubs() {
                    dataProvider.subscription
                    .getCustomerSubs()
                    .done(function (data) {
                        vm.plan.subsUsers = data.subsMaxUserCount == null || data.subsMaxUserCount == "" || data.subsMaxUserCount < 2 ? 2 : data.subsMaxUserCount;
                        vm.plan.subsGuest = data.subsMaxGuestCount;
                        
                        if (data.subsPlanCode == "fileplan_starter_aud") {
                            vm.plan.code = 1;
                            vm.plan.title = 'Starter Plan';
                            vm.plan.price = 40;
                            vm.plan.pricePerUser = 20;
                            vm.plan.includedUsers = 2;

                            vm.currentPlan = vm.plan.code;
                            vm.clickSelectPlan1();
                        }
                        if (data.subsPlanCode == "fileplan_standard_aud") {
                            vm.plan.code = 2;
                            vm.plan.title = 'Standard Plan';
                            vm.plan.price = 50;
                            vm.plan.pricePerUser = 20;
                            vm.plan.includedUsers = 2;
                            
                            vm.currentPlan = vm.plan.code;
                            vm.clickSelectPlan2();
                        }
                        if (data.subsPlanCode == "fileplan_plus_aud") {
                            vm.plan.code = 3;
                            vm.plan.title = 'Plus Plan';
                            vm.plan.price = 200;
                            vm.plan.pricePerUser = 20;
                            vm.plan.includedUsers = 2;

                            vm.currentPlan = vm.plan.code;
                            vm.clickSelectPlan3();
                        }

                        vm.du_isAvailable1(isPlanAvailable(1));
                        vm.du_isAvailable2(isPlanAvailable(2));
                        vm.du_isAvailable3(isPlanAvailable(3));
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;

                        console.error(e);
                    });
                }
                function _test() {
                    vm.totalSpaceUsedMB = 10 * 1024;

                    var subsPlanCode = "fileplan_standard_aud"; //fileplan_starter_aud fileplan_standard_aud fileplan_plus_aud
                    vm.plan.activeUsers = 5;
                    vm.plan.activeGuest = 25;
                    vm.plan.subsUsers = 7; // never go below 2
                    vm.plan.subsGuest = 25;
                    
                    if (subsPlanCode == "fileplan_starter_aud") {
                        vm.plan.code = 1;
                        vm.plan.title = 'Starter Plan';
                        vm.plan.price = 40;
                        vm.plan.pricePerUser = 20;
                        vm.plan.includedUsers = 2;

                        vm.currentPlan = vm.plan.code;
                        vm.clickSelectPlan1();
                    }
                    if (subsPlanCode == "fileplan_standard_aud") {
                        vm.plan.code = 2;
                        vm.plan.title = 'Standard Plan';
                        vm.plan.price = 50;
                        vm.plan.pricePerUser = 20;
                        vm.plan.includedUsers = 2;

                        vm.currentPlan = vm.plan.code;
                        vm.clickSelectPlan2();
                    }
                    if (subsPlanCode == "fileplan_plus_aud") {
                        vm.plan.code = 3;
                        vm.plan.title = 'Plus Plan';
                        vm.plan.price = 200;
                        vm.plan.pricePerUser = 20;
                        vm.plan.includedUsers = 2;

                        vm.currentPlan = vm.plan.code;
                        vm.clickSelectPlan3();
                    }

                    vm.du_isAvailable1(isPlanAvailable(1));
                    vm.du_isAvailable2(isPlanAvailable(2));
                    vm.du_isAvailable3(isPlanAvailable(3));
                };
            })
            .fail(function (e) {
                console.error(e);
            });
        };
        vm.attached = function () {
            $(".higlight-plan1").unbind();
            //$(".higlight-plan2").unbind();
            //$(".higlight-plan3").unbind();

            $(".higlight-plan1").bind("click", function () {
                vm.clickSelectPlan1();
            });
            //$(".higlight-plan2").bind("click", function () {
            //    vm.clickSelectPlan2();
            //});

            //$(".higlight-plan3").bind("click", function () {
            //    vm.clickSelectPlan3();
            //});

            $(".higlight-plan1").bind("mouseover", function () {
                vm.du_isOverPlan1(true);
            });
            $(".higlight-plan1").bind("mouseout", function () {
                vm.du_isOverPlan1(false);
            });
            //$(".higlight-plan2").bind("mouseover", function () {
            //    vm.du_isOverPlan2(true);
            //});
            //$(".higlight-plan2").bind("mouseout", function () {
            //    vm.du_isOverPlan2(false);
            //});
            //$(".higlight-plan3").bind("mouseover", function () {
            //    vm.du_isOverPlan3(true);
            //});
            //$(".higlight-plan3").bind("mouseout", function () {
            //    vm.du_isOverPlan3(false);
            //});
        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        vm.du_isSelectUserQuantityEnabled = ko.observable(false);
        vm.du_isSelectedPlan1 = ko.observable(false);
        vm.du_isSelectedPlan2 = ko.observable(false);
        vm.du_isSelectedPlan3 = ko.observable(false);
        vm.du_isAvailable1 = ko.observable(false);
        vm.du_isAvailable2 = ko.observable(false);
        vm.du_isAvailable3 = ko.observable(false);

        vm.du_planText = function (plan) {
            if (plan == vm.plan.code) {
                return "Current Plan";
            }
            if (plan == 1 && plan < vm.plan.code) {
                return "Downgrade to Starter";
            }
            if (plan == 2 && plan < vm.plan.code) {
                return "Downgrade to Standard";
            }
            if (plan == 2 && plan > vm.plan.code) {
                return "Upgrade to Standard";
            }
            if (plan == 3 && plan > vm.plan.code) {
                return "Upgrade to Plus";
            }

            return "";
        };

        vm.clickSelectUserQuantity = function () {
            vm.plan.isCurrent = vm.currentPlan == vm.plan.code;

            setSubscriptionPlan(vm.plan.code);

            return false;
        };
        vm.selectUserQuantity = ko.asyncCommand({
            canExecute: function (isExecuting) {
                var b = !(!vm.du_isAvailable1() && !vm.du_isAvailable2() && !vm.du_isAvailable3());

                return !isExecuting && b && vm.du_isSelectUserQuantityEnabled();
            },
            execute: function (complete) {
                vm.plan.isCurrent = vm.currentPlan == vm.plan.code;

                setSubscriptionPlan(vm.plan.code);
                
                complete();
            }
        });
        vm.clickSelectPlan1 = function () {
            vm.plan.code = 1;            
      
            vm.du_isSelectedPlan1(true);
            vm.du_isSelectedPlan2(false);
            vm.du_isSelectedPlan3(false);

            vm.du_isSelectUserQuantityEnabled(isPlanAvailable(1));
        };
        vm.clickSelectPlan2 = function () {
            return;

            vm.plan.code = 2;            
    
            vm.du_isSelectedPlan1(false);
            vm.du_isSelectedPlan2(true);
            vm.du_isSelectedPlan3(false);

            vm.du_isSelectUserQuantityEnabled(isPlanAvailable(2));
        };
        vm.clickSelectPlan3 = function () {
            return;

            vm.plan.code = 3;            
       
            vm.du_isSelectedPlan1(false);
            vm.du_isSelectedPlan2(false);
            vm.du_isSelectedPlan3(true);

            vm.du_isSelectUserQuantityEnabled(isPlanAvailable(3));
        };
        vm.clickPlan1 = function () {
            vm.plan.code = 1;
            
            setSubscriptionPlan(1);
        };
        vm.clickPlan2 = function () {
            return;

            vm.plan.code = 2;

            setSubscriptionPlan(2);            
        };
        vm.clickPlan3 = function () {
            return;

            vm.plan.code = 3;

            setSubscriptionPlan(3);
        };

        function isPlanAvailable(plan) {
            if (plan == vm.currentPlan)
                return true;

            var d = 0, g = 0;
            var b = false;

            if (plan == 1) {
                d = 100 * 1024;
            }
            if (plan == 2) {
                d = 1000 * 1024;
            }
            if (plan == 3) {
                d = 5000 * 1024;
            }
                  
            b = vm.totalSpaceUsedMB <= d;

            if (plan == 1) {
                g = 25;
            }
            if (plan == 2) {
                g = 150;
            }
            if (plan == 3) {
                g = 500;
            }

            b = b && vm.plan.activeGuest <= g;

            return b;
        }
        function setSubscriptionPlan(plan) {
            if (plan == 1) {
                vm.plan.title = 'Starter Plan';
                vm.plan.price = 40;
                vm.plan.pricePerUser = 20;
                vm.plan.includedUsers = 2;
            }
            if (plan == 2) {
                vm.plan.title = 'Standard Plan';
                vm.plan.price = 50;
                vm.plan.pricePerUser = 20;
                vm.plan.includedUsers = 2;
            }
            if (plan == 3) {
                vm.plan.title = 'Plus Plan';
                vm.plan.price = 200;
                vm.plan.pricePerUser = 20;
                vm.plan.includedUsers = 2;
            }

            dialog.show("modals/secured/subscription/select", [vm.plan]);
        }

        return vm;
    }
);
